webpackJsonp([2638498282051],{

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _moment = __webpack_require__(83);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post = function (_React$Component) {
	  _inherits(Post, _React$Component);
	
	  function Post() {
	    _classCallCheck(this, Post);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Post.prototype.render = function render() {
	    var _props$data$node$fron = this.props.data.node.frontmatter,
	        title = _props$data$node$fron.title,
	        category = _props$data$node$fron.category,
	        description = _props$data$node$fron.description;
	    var _props$data$node$fiel = this.props.data.node.fields,
	        slug = _props$data$node$fiel.slug,
	        categorySlug = _props$data$node$fiel.categorySlug,
	        date = _props$data$node$fiel.date;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'post' },
	      _react2.default.createElement(
	        'div',
	        { className: 'post__meta' },
	        _react2.default.createElement(
	          'time',
	          { className: 'post__meta-time', dateTime: (0, _moment2.default)(date).format('MMMM D, YYYY') },
	          (0, _moment2.default)(date).format('MMMM YYYY')
	        ),
	        _react2.default.createElement('span', { className: 'post__meta-divider' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'post__meta-category', key: categorySlug },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: categorySlug, className: 'post__meta-category-link' },
	            category
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'post__title' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'post__title-link', to: slug },
	          title
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'post__description' },
	        description
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'post__readmore', to: slug },
	        'Read'
	      )
	    );
	  };
	
	  return Post;
	}(_react2.default.Component);
	
	exports.default = Post;
	module.exports = exports['default'];

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Post = __webpack_require__(47);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagTemplateDetails = function (_React$Component) {
	  _inherits(TagTemplateDetails, _React$Component);
	
	  function TagTemplateDetails() {
	    _classCallCheck(this, TagTemplateDetails);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TagTemplateDetails.prototype.render = function render() {
	    var items = [];
	    var tagTitle = this.props.tag;
	    var posts = this.props.posts;
	    posts.forEach(function (post) {
	      items.push(_react2.default.createElement(_Post2.default, { data: post, key: post.node.fields.slug }));
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'content__inner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'page__title' },
	            'All Posts tagged as "',
	            tagTitle,
	            '"'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'page__body' },
	            items
	          )
	        )
	      )
	    );
	  };
	
	  return TagTemplateDetails;
	}(_react2.default.Component);
	
	exports.default = TagTemplateDetails;
	module.exports = exports['default'];

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Sidebar = __webpack_require__(23);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _TagTemplateDetails = __webpack_require__(247);
	
	var _TagTemplateDetails2 = _interopRequireDefault(_TagTemplateDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagTemplate = function (_React$Component) {
	  _inherits(TagTemplate, _React$Component);
	
	  function TagTemplate() {
	    _classCallCheck(this, TagTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TagTemplate.prototype.render = function render() {
	    var title = this.props.data.site.siteMetadata.title;
	    var tag = this.props.pathContext.tag;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: 'All Posts tagged as "' + tag + '" - ' + title }),
	      _react2.default.createElement(_Sidebar2.default, { siteMetadata: this.props.data.site.siteMetadata }),
	      _react2.default.createElement(_TagTemplateDetails2.default, { posts: this.props.data.allMarkdownRemark.edges, tag: tag })
	    );
	  };
	
	  return TagTemplate;
	}(_react2.default.Component);
	
	exports.default = TagTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tag-template-jsx-3d3f503ac46372d15db0.js